export default "__VITE_PUBLIC_ASSET__bb355dbd__"